export const API = {
    ORDER: '/api/order',
    UPGRADE_ORDER: '/api/order/upgradePrinter',
    OOBE_ORDER: '/api/oobe/order',
};
